import { useState } from "react";

import useModal from "@/lib/hooks/useModal";
import { useRouter } from "next/navigation";

const useSearchModal = () => {
  const { isOpen, openModal, closeModal, toggleModal } = useModal(
    "searchBar",
    () => {},
    false,
    true
  );
  const router = useRouter();
  const [input, setInput] = useState<string>("");
  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = Object.fromEntries(new FormData(event.currentTarget));
    if (router) router.push("/sok?sok=" + data.search);
    closeModal();
    setInput("");
  };
  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
    input,
    setInput,
    onSubmit
  };
};

export default useSearchModal;
